import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { createText } from './TextCommands';
import { TextMechanics } from './TextMechanics';
import { textTool } from './TextTool';
import { textToolboxItem } from './TextToolboxItem';

export class TextPackage implements Package {

    public install = (host: PackageHost) => host
        .register(TextMechanics, 'singleton')
        .plug(inTool(textTool))
        .plug(inToolboxItems(textToolboxItem))
        .plug(inCommands(createText))
        .start(TextMechanics)
        ;
}
